import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DeviceWidth } from 'ecs-react-components/dist/index.es';
import { messages } from './FollowUpPlan.i18n';
import { FollowUpTaskNotes } from './FollowUpTaskNotes';

const dateCell = (cell, row, timeZoneAbbr) => (
  <div>
    <span>
      <span>{ cell.datePart }</span>
      {
        cell.timePart ? (
          <span>&nbsp;
            <span className="visible-xs-inline"><br /></span>
            <span style={{ display: 'inline-block' }}>
              { '(' + cell.timePart + ')' }
              { timeZoneAbbr !== row.timeZoneAbbreviation ? ' ' + row.timeZoneAbbreviation : '' }
            </span>
          </span>
        )
          : null
      }
    </span><br />
    <FormattedMessage { ...messages.status[row.dateStatus] } />
  </div>
);

const providerCell = (cell) => (
  <div>
    <span>
      <span>{ cell.first }</span>
      {
        cell.last ?
          <span>
            <span className="visible-xs-inline"><br /></span>
            <span>{ cell.last }</span>
          </span>
          : null
      }
    </span>
  </div>
);

const taskStatusCell = (cell, row, key) => {
  const theTask = row.tasks.find((task) => task.propertyCategoryId === key);
  let iconCss = 'icoc icoc-greencheck follow-up-check ';
  if (theTask && !theTask.isAddressed) {
    iconCss = 'fa-regular fa-square understated fs-6';
  }
  return (
    <div>
      {
        theTask ? (
        <span className={iconCss}>
          <span className="square"></span>
          <span className="checkmark"></span>
        </span>) :
        <span className="na">
          <FormattedMessage { ...messages.status.notApplicable } />
        </span>
      }
    </div>
  );
};

const taskNotesCell = (cell, row, taskNames) => (
  <FollowUpTaskNotes appointment={row} taskNames={taskNames} />
);

export const columns = (msgs, timeZoneAbbr, dynamicCols) => {
  const tableColumns = [
    {
      name: 'ID',
      dataField: 'ptFollowUpAppointmentId',
      hidden: true,
      formatted: true,
    },
    {
      name: msgs.columns.label,
      dataCellCss: 'followup-label-col',
      headerCellCss: 'followup-label-col',
      dataField: 'label',
    },
    {
      name: msgs.columns.label,
      hidden: true,
      dataField: 'ptFollowUpAppointmentId',
      customExpansion: true,
      renderField: (cell, row) => taskNotesCell(cell, row, dynamicCols),
      maxCollapsedWidth: DeviceWidth.Large.maxWidth,
    },
    {
      name: msgs.columns.date,
      dataCellCss: 'followup-date-col',
      headerCellCss: 'followup-date-col',
      dataField: 'displayDate',
      columnTitle: true,
      renderField: (cell, row) => dateCell(cell, row, timeZoneAbbr),
    },
    {
      name: msgs.columns.provider,
      dataCellCss: 'followup-provider-col',
      headerCellCss: 'followup-provider-col',
      dataField: 'provider',
      renderField: providerCell,
    },
  ];

  let dynCols = null;
  const cellCss = 'status-indicator d-none d-md-table-cell';
  if (dynamicCols) {
    dynCols = dynamicCols.map((taskName) => ({
      name: taskName.value,
      dataField: 'label',
      formatted: true,
      dataCellCss: cellCss,
      headerCellCss: cellCss,
      renderField: (cell, row) => taskStatusCell(cell, row, taskName.key),
    }));
  }

  return tableColumns.concat(dynCols);
};
